<template>
  <div>
    <div id="header-bar" class="border-bar">
      <div class="left-item">
        <a class="button app-primary" @click="startAgain()">
          <i class="fas fa-sync"></i>
          Start Again
        </a>
      </div>
      <div class="right-item">
        <a class="button app-accent" @click="viewFavorites()">
          <i class="fas fa-heart"></i>
          View Favorites
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'app-header',
  mixins: [],
  components: {},
  data() {
    return {}
  },
  props: {
    showFavorites: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  created() {
  },
  methods: {
    startAgain: function () {
      const origin = this.$route.params.origin;
      if (origin) {
        return this.$router.push({
          path: '/community/move-in/' + origin
        })
      }
      this.$router.push({
        path: '/community'
      })
    },

    viewFavorites: function () {
      const origin = this.$route.params.origin;
      if (origin) {
        return this.$router.push({
          path: '/favorite/' + origin
        })
      }
      this.$router.push({
        path: '/favorite'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/Header.vue